export default {"src":"https://fishbrain.com/_next/static/media/northDakota.7cf42ec7.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};